import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Home from "./pages/Home";
import Login from "./pages/Login";
import SelectChampion from "./pages/SelectChampion";
import Game from "./pages/Game";
import Ranking from "./pages/Ranking";
import Regole from "./pages/Regole";
import Termini from "./pages/Termini";
import Contatti from "./pages/Contatti";
import AuthCallback from "./pages/AuthCallback";
import "./App.css";

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/select-champion" element={<SelectChampion />} />
          <Route path="/game" element={<Game />} />
          <Route path="/ranking" element={<Ranking />} />
          <Route path="/regole" element={<Regole />} />
          <Route path="/termini" element={<Termini />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
